import { useMemo } from "react";
import { endOfYear, getYear, startOfYear } from "date-fns";
import { FiltersTypes } from "@common/types/filters/general";
import { useAvailableYears } from "@components/settings/Directory/useAvailableYears";
import { YearSelect } from "./YearSelect";

interface YearFilterProps {
    filters: Pick<FiltersTypes, "start" | "end">;
    onChange: (filters: Pick<FiltersTypes, "start" | "end">) => void;
}

export const YearFilter: React.FC<YearFilterProps> = ({
    filters,
    onChange,
}) => {
    const availableYears = useAvailableYears();

    const selectedYear = useMemo(() => {
        if (!filters.start || !filters.end) {
            return 0;
        }

        return getYear(filters.start);
    }, [filters]);

    const handleChange = (year: number) => {
        onChange({
            ...filters,
            ...(year !== 0
                ? {
                      start: startOfYear(new Date(year, 1)),
                      end: endOfYear(new Date(year, 1)),
                  }
                : { start: undefined, end: undefined }),
        });
    };

    return (
        <YearSelect
            value={selectedYear}
            availableYears={availableYears}
            onChange={handleChange}
        />
    );
};
